import React from "react";
import { taskService } from "../services/api";
import "../styles/TaskList.css";

const TaskList = ({ tasks, onTaskUpdated }) => {
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      try {
        await taskService.deleteTask(id);
        onTaskUpdated();
      } catch (err) {
        alert("Error deleting task");
      }
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const task = tasks.find((t) => t._id === id);
      await taskService.updateTask(id, task.title, task.description, newStatus);
      onTaskUpdated();
    } catch (err) {
      alert("Error updating task");
    }
  };

  return (
    <div className="task-list">
      <h2>Your Tasks</h2>
      {tasks.length === 0 ? (
        <p>No tasks yet. Create one to get started!</p>
      ) : (
        <ul>
          {tasks.map((task) => (
            <li key={task._id} className={`task-item ${task.status}`}>
              <div className="task-content">
                <h3>{task.title}</h3>
                <p>{task.description}</p>
              </div>
              <div className="task-actions">
                <select
                  value={task.status}
                  onChange={(e) => handleStatusChange(task._id, e.target.value)}
                  className="status-select"
                >
                  <option value="pending">Pending</option>
                  <option value="in-progress">In Progress</option>
                  <option value="completed">Completed</option>
                </select>
                <button
                  onClick={() => handleDelete(task._id)}
                  className="delete-btn"
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TaskList;
